import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoGatewaysComponent } from './listado-gateways/listado-gateways.component';

const routes: Routes = [
  {
    path: '',
    component: ListadoGatewaysComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GatewaysRoutingModule {}
